export default function Skeleton()
{
    return (
        <div className="w-[280px] h-[50vh] bg-slate-200 animate-pulse rounded-xl mb-20">

        </div>
    )
}